/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import { StepModalOptionText } from '../styled';
import { OwnerOption, OwnerOptionWrapper } from './styled';
import Icon from '../../Icon';
import OwnerIcon from '../../../public/static/images/new_ad/icons/icon-owner.svg';
import AgentIcon from '../../../public/static/images/new_ad/icons/icon-agent.svg';
import { FORM_VALUES } from '../../../utils/helpers/constants';
import { ItemCreationLayout } from '../ItemCreationLayout';
import useScreenSize from '../../../hooks/useScreenSize';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';
import { useClient } from '../../../hooks/useClient';
import { ItemCreateContactTypeEnum } from '../../../graphql/types';

interface SelectOwnerTypeStepProps {
  goNext: () => void;
}

export const SelectOwnerTypeStep: React.FC<SelectOwnerTypeStepProps> = ({
  goNext
}) => {
  const { t } = useTranslation();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const onOptionClick = () => {
    goNext();
  };

  const OwnerConfig = [
    {
      icon: OwnerIcon,
      text: t('new_ad.i_am_owner'),
      dataStat: generateDataStat('create_ad_step3_owner', isSmall, isClient),
      onClick: () => {
        change(FORM_VALUES.owner, ItemCreateContactTypeEnum.Owner);
        onOptionClick();
      }
    },
    {
      icon: AgentIcon,
      text: t('new_ad.i_am_agent'),
      dataStat: generateDataStat('create_ad_step3_agent', isSmall, isClient),
      onClick: () => {
        change(FORM_VALUES.owner, ItemCreateContactTypeEnum.Agent);
        onOptionClick();
      }
    }
  ];

  return (
    <ItemCreationLayout
      cypress="owner-modal"
      contentCypress="owner-modal__content"
    >
      <OwnerOptionWrapper>
        {OwnerConfig.map(ownerType => (
          <OwnerOption
            key={ownerType.text}
            onClick={ownerType.onClick}
            data-cy="owner-modal__option"
            data-stat={ownerType.dataStat}
            $isDefaultStyles
          >
            <Icon
              IconComponent={ownerType.icon}
              width={48}
              height={48}
              indent={false}
            />
            <StepModalOptionText tag="body_3">
              {ownerType.text}
            </StepModalOptionText>
          </OwnerOption>
        ))}
      </OwnerOptionWrapper>
    </ItemCreationLayout>
  );
};
